import React from 'react';
import { useTranslation } from 'react-i18next';

import { PageHeader } from 'src/components/common/page-header';
import { LoginRuleForm } from 'src/components/login-rules/form';
// import PermissionRole from 'src/components/manage-log-in-rules/permission-role-section';

export const LogInRuleFormPage = () => {
  const { t } = useTranslation();
  const breadCrumbsProps = {
    items: [{ label: t('manage-log-in-rules.title-add-new', 'Add New Rule') }],
  };
  const title = t('manage-log-in-rules.title-add-new', 'Add New Rule');

  return (
    <>
      <PageHeader title={title} breadcrumbs={breadCrumbsProps} />
      <LoginRuleForm />
      {/*<PermissionRole />*/}
    </>
  );
};
